export function isLoading(list) {
  return list === null;
}

// Проверяем, был ли загружен список
export function hasItBeenLoaded(list) {
  return !(list === null);
}
